import React from 'react';
import { Link } from 'react-router-dom';
import './HelpButton.css';

const HelpButton = () => {
  return (
    <Link to="/support" className="help-button" title="Contact Support">
      <span className="help-icon">?</span>
    </Link>
  );
};

export default HelpButton;

